import React, { useEffect } from "react";
import { Table, Button } from "antd";
import { ColumnsType } from "antd/es/table";
import { useJxcModel } from "../jxcModel";
import { ISCMJxcDetail, ISCMJxcDetailPurchasePin } from "../jxcService";
import { useDictModel } from "@/views/base/dict/dictModel";
import { formatNum } from "@/utils/utils";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";




export function DataTable1() {
    const {
        purchasePinData, selectedRowKeys, pinPgCfg, selectedRow,
        loadMaterialData, exportJxcPin
    } = useJxcModel();
    const { getTreeNodeName } = useDictModel(() => []);

    useEffect(() => {
        if (selectedRowKeys.length > 0) {
            loadMaterialData();
        }
    }, [selectedRowKeys])

    const columns: ColumnsType<ISCMJxcDetailPurchasePin> = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            align: "center",
            render: (t, r, i) => i + 1
        }, {
            title: '从属站点',
            width: 160,
            dataIndex: 'shopName',
        }, {
            title: '仓库',
            width: 140,
            dataIndex: 'warehouseName',
        }, {
            title: '出入库日期',
            width: 160,
            dataIndex: 'stockIoTime',
        }, {
            title: '单据类型',
            width: 120,
            dataIndex: 'tradeTypeName',
        }, {
            title: '对方单位',
            width: 200,
            dataIndex: 'userName',
        }, {
            title: '单号',
            width: 180,
            dataIndex: 'code',
        }, {
            title: '货位',
            width: 140,
            dataIndex: 'shelfCode',
        }, {
            title: '数量',
            width: 100,
            dataIndex: 'num',
        }, {
            title: '单价',
            width: 100,
            dataIndex: 'price',
        }, {
            title: '金额',
            width: 100,
            dataIndex: 'amount',
        }, {
            title: '成本',
            width: 100,
            dataIndex: 'costAmount',
        }, {
            title: '毛利',
            width: 100,
            dataIndex: 'profit',
        }, {
            title: '数量余额',
            width: 100,
            dataIndex: 'surplusNum',
        }, {
            title: '金额余额',
            width: 100,
            dataIndex: 'surplusAmount',
        }, {
            title: '业务员',
            width: 120,
            dataIndex: 'createUser',
        }
    ];

    return (
        <>
            <YhAuth resCode={ResourceAuthEnum.VRM2_STT_JXC_GOODLEDGER_EX}>
                <Button
                    className={`ml-15`}
                    type="link"
                    shape="round"
                    onClick={() => exportJxcPin()}
                >导出</Button>
            </YhAuth>
            <div className="record-warp">
                <div className="record-item">
                    <label>商品编号:</label>
                    <div className="f1">
                        <span className="text">{selectedRow?.materialCode}</span>
                    </div>
                </div>
                <div className="record-item">
                    <label>商品名称:</label>
                    <div className="f1">
                        <span className="text">{selectedRow?.materialName}</span>
                    </div>
                </div>
                <div className="record-item">
                    <label>商品类型:</label>
                    <div className="f1">
                        <span className="text">{selectedRow?.typeName}</span>
                    </div>
                </div>
                <div className="record-item">
                    <label style={{ width: "90px" }}>发动机型号:</label>
                    <div className="f1">
                        <span className="text">{ }</span>
                    </div>
                </div>
                <div className="record-item">
                    <label>替换编号:</label>
                    <div className="f1">
                        <span className="text">{selectedRow?.replaceCode}</span>
                    </div>
                </div>
            </div>
            <Table
                bordered
                rowKey={record => record.id}
                columns={columns}
                dataSource={purchasePinData}
                pagination={{
                    ...pinPgCfg,
                    showSizeChanger: true,
                    defaultPageSize: 25,
                    pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                    position: ["bottomRight"],
                    showTotal: () => `共${pinPgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadMaterialData({ pageNum, pageSize })
                    }
                }}
                // onRow={record => ({
                //     onClick: () => onRow(record.id)
                // })}
                scroll={{ x: 'max-content', y: "calc(100vh - 340px)" }}
            />
        </>

    )
}